<template>
  <div class="topicBox">
    <div class="gradientBox">
      <div class="titleBox">
        <div class="titleLeft" @click="closeWebs">
          <img src="../../assets/images/titleArrow.png" alt="" />
        </div>
        <div class="titleCentre">
          {{ majorType == 1 ? '临床思维' : majorType == 2 ? '临床思辨能力' : majorType == 3 ? '中西医思维与诊疗能力' : majorType == 4 ? '病史采集' : '临床思维' }}
        </div>
        <div
          class="titleRight"
          @click="titleRightClick"
          :class="{ active: titleRightFlag }"
        >
          <!-- <img src="../../assets/images/centreIcon.png" alt="" /> -->
        </div>
      </div>
      <ul class="typeBox">
        <li @click="wrongQuestion">
          <img src="../../assets/images/typeOne.png" alt="" />
          <span>错题</span>
        </li>
        <li @click="collect">
          <img src="../../assets/images/typeTwo.png" alt="" />
          <span>收藏</span>
        </li>
        <li @click="note">
          <img src="../../assets/images/typeThree.png" alt="" />
          <span>笔记</span>
        </li>
        <li @click="testCreation">
          <img src="../../assets/images/typeFour.png" alt="" />
          <span>智能组题</span>
        </li>
      </ul>
      <div class="tabsBox">章节练习</div>
    </div>
    <ul class="topicOneBox">
      <li
        v-for="(item, index) in topicList"
        :key="index"
        :class="{ active: topicActive == index }"
      >
        <div class="topicOne" @click="topicOneClick(item, index)">
          <div class="oneLeft">
            <div class="arrow">
              <img src="../../assets/images/bottomArrow.png" alt="" />
            </div>
            <div class="title">{{ item.label }}</div>
          </div>
          <div class="oneRight">
            <span>{{ item.studyNum }}</span>
            /
            <span>{{ item.totalNum }}</span>
          </div>
        </div>
        <ul class="topicTow" v-if="topicActive == index">
          <li
            v-for="(v, i) in detailsList"
            :key="i"
            @click="topicTwoClick(v, i)"
          >
            <div class="towLeft">{{ v.label }}</div>
            <div class="towRight">
              <!-- <i class="el-icon-lock" v-if="shouldShowLock(v, i)"></i> -->
              <span>{{ v.studyNum }}/{{ v.totalNum }}</span>
              <img src="../../assets/images/towRightArrow.png" alt="" />
            </div>
          </li>
        </ul>
      </li>
    </ul>
    <van-popup
      v-model="suspensionFlag"
      position="top"
      round
      class="suspensionBox"
    >
      <div class="titleCentre">{{ majorType == 1 ? '临床思维' : majorType == 2 ? '临床思辨能力' : majorType == 3 ? '中西医思维与诊疗能力' : majorType == 4 ? '病史采集' : '临床思维' }}</div>
      <div class="suspension">
        <ul class="suspensionLeft">
          <li
            v-for="(item, index) in suspensionLeftList"
            :key="index"
            :class="{ active: suspensionLeftActive == index }"
            @click="suspensionLeftListClick(item, index)"
          >
            <div class="suspensionLeftName">{{ item.label }}</div>
          </li>
        </ul>
        <ul class="suspensionRight">
          <li
            v-for="(item, index) in suspensionRightList"
            :key="index"
            :class="{ active: suspensionRightActive == index }"
            @click="suspensionRightListClick(item, index)"
          >
            <div class="suspensionRightName">{{ item.label }}</div>
          </li>
        </ul>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getToken, setToken } from "@/utils/auth";
import { getTree, getById } from "@/api/subject/index.js";
// studyBankList,
// getByStudyBankId,
// getQuestions,
export default {
  data() {
    return {
      // titleName: "临床思维能力",
      titleRightFlag: false,
      suspensionFlag: false,
      tabsList: [],
      tabsActive: 0,
      topicList: [],
      isUnlock: true,
      // isDemo: null,
      topicActive: null,
      detailsList: [],
      suspensionLeftList: [],
      suspensionLeftActive: 0,
      suspensionRightList: [],
      suspensionRightActive: 0,
      cardBoxFlag: false,
      cardFlag: false,
      startY: 0,
      endY: 0,
      allowToggle: false,
      skillId: "",
      skillName: "",
      skillIntegral: "",
      productInfoId: "",
      majorType: 1,
    };
  },
  created() {
    // this.majorType = 1;
    this.androidIos();
    // this.majorType = this.$route.query.majorType;
    // this.getTreeList();
  },
  mounted() {
    window.getU3dParams = this.getU3dParams;
    window.buyFirstStaionActionBack = this.buyFirstStaionActionBack;
  },
  methods: {
    judgeClient() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //判断是否是 android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
      console.log("是否是Android：" + isAndroid); //true,false
      console.log("是否是iOS：" + isIOS);
      if (isAndroid) {
        return "Android";
      } else if (isIOS) {
        return "IOS";
      } else {
        return "PC";
      }
    },
    androidIos() {
      if (this.judgeClient() == "Android") {
        this.callAndroidFunctionWithParameter();
      } else {
        this.getAppParams();
        this.buyFirstStaionActionBack();
      }
    },
    callAndroidFunctionWithParameter() {
      // let data = {
      //   rounter: 109 /* int 类型枚举变量 */,
      //   callBack: true /* bool 类型，告诉客户端是否需要回调 */,
      //   params: {},
      // };
      const that = this;
      // if (this.isUnlock) {
        this.$bridge.callmethod(
          "WebAction.getAppParams",
          { ceshi: "ceshi" },
          (res) => {
            // nativeTunnel为方法名
            // 注意this指向问题
            // alert(res); // 这里能拿到app的返回值哦!
          }
        );
      // } else {
      //   this.$bridge.callmethod(
      //     "WebAction.buyFirstStaionAction",
      //     JSON.stringify({
      //       // 给安卓传参
      //       skillId: this.skillId,
      //       skillName: this.skillName,
      //       skillIntegral: this.skillIntegral,
      //       productInfoId: this.productInfoId
      //     })
      //   );
      // }
      this.$bridge.registermethod("getU3dParams", (data) => {
        const jsonData = JSON.parse(data);
        const token = jsonData.token;
        this.majorType = 1
        setToken(token);
        this.$nextTick(() => {
          this.getTreeList(token);
        });
      });
      this.$bridge.registermethod("buyFirstStaionActionBack", (data) => {
        const jsonData = JSON.parse(data);
        const token = jsonData.token;
        this.majorType = 1;
        setToken(token);
        this.$nextTick(() => {
          this.getTreeList(token);
          this.topicActive = null;
        });
        // setTimeout(() => {
        //   this.getTreeList(token);
        // }, 2000);
      });
    },
    getU3dParams(data) {
      const jsonData = JSON.parse(data);
      const token = jsonData.token;
      this.majorType = 1;
      setToken(token);
      this.$nextTick(() => {
        this.getTreeList(token);
      });
    },
    buyFirstStaionActionBack(data) {
      const jsonData = JSON.parse(data);
      const token = jsonData.token;
      this.majorType = 1;
      setToken(token);
      this.$nextTick(() => {
        this.getTreeList(token);
        this.topicActive = null;
      });
    },
    getAppParams() {
      try {
        //使用此方法,会报错,因此使用try-catch
        // if (this.isUnlock) {
          webkit.messageHandlers.getAppParams.postMessage(
            "js调用ios",
            (data) => {}
          );
        // } else {
        //   webkit.messageHandlers.buyFirstStaionAction.postMessage(
        //     JSON.stringify({
        //       skillId: this.skillId,
        //       skillName: this.skillName,
        //       skillIntegral: this.skillIntegral,
        //       productInfoId: this.productInfoId
        //     })
        //   );
        // }
      } catch (error) {
        console.log("WKWebView post message error: ", error);
      }
    },
    closeWebs() {
      if (this.judgeClient() == "Android") {
        this.closeAndroid();
      } else {
        this.closeIos();
      }
      //  this.$router.push({
      //     path: "/standing",
      //   });
    },
    closeAndroid() {
      this.$bridge.callmethod(
        "WebAction.closeWeb",
        { ceshi: "ceshi" },
        (res) => {
          // nativeTunnel为方法名
          // 注意this指向问题
          // alert(res); // 这里能拿到app的返回值哦!
        }
      );
    },
    closeIos() {
      try {
        //使用此方法,会报错,因此使用try-catch
        webkit.messageHandlers.closeWeb.postMessage("js调用ios");
      } catch (error) {
        console.log("WKWebView post message error: ", error);
      }
    },
    onTouchStart(event) {
      this.startY = event.touches[0].clientY;
      this.allowToggle = true;
    },
    onTouchMove(event) {
      if (!this.allowToggle) return;
      this.endY = event.touches[0].clientY;
      const deltaY = this.endY - this.startY;
      if (deltaY > 0) {
        this.toggleCard();
        this.allowToggle = false;
      }
    },
    onTouchEnd() {
      this.allowToggle = false;
    },
    cardUpClick() {
      if (!this.cardFlag) {
        this.cardFlag = !this.cardFlag;
        this.cardBoxFlag = this.cardFlag;
      }
    },
    toggleCard() {
      this.cardBoxFlag = false;
      setTimeout(() => {
        this.cardFlag = this.cardBoxFlag;
      }, 500);
    },
    async getTreeList(token) {
      // const tokenz = 'eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjozMDUyLCJ1c2VyX2lkIjozNjYzLCJvcmdfaWQiOjQ2LCJ1c2VyX2tleSI6IjlmNWQzMDFlLTdmNmItNDhlMC1iMGJiLTA2Y2EwNzk1MzhjYSIsImRldmljZV90eXBlIjoiYXBwLXNraWxsIiwidXNlcm5hbWUiOiIxMzUxMTExMTExMSJ9.RxhphO6nCwkWJ6ZquJ4putHViPanGSdN89mCkJ6hD6uV5HBf9czVvQi6pROV7TkFmh3snVfvyZQGH5Ai6gsWDA'
      const setList = {
        majorType: this.majorType
      }
      const { data } = await getTree(token,setList);
      if (data[0].children) {
        this.topicList = data[0].children;
        // this.skillId = this.topicList[0].skillId;
        // this.getByIdData(this.topicList[0].productInfoId);
      }
      // this.titleName = data[0].label;
      // const setList = {
      //   type: 50,
      // };
      // const { data } = await getTree(setList, token);
      // this.titleName = data[0].label;
      // this.suspensionLeftList = data;
      // if (data[0].children) {
      //   this.suspensionRightList = data[0].children;
      //   this.getStudyBankList(data[0].children[0].id);
      //   this.tabsActive = 0;
      //   this.topicActive = null;
      // } else {
      //   this.suspensionRightList = [];
      //   this.tabsList = [];
      // }
    },
    // productInfoId
    async getByIdData(id) {
      const { data } = await getById(id);
      console.log("data", data);
      this.skillId = data.skillId;
      this.skillName = data.name;
      this.skillIntegral = data.skillExchangeIntegral;
      this.productInfoId = data.id;
    },
    async getStudyBankList(id) {
      const setList = {
        categoryId: id,
      };
      const { data } = await studyBankList(setList);
      this.tabsList = data;
      if (this.tabsList.length > 0) {
        this.getByStudyBankIdList(this.tabsList[0].studyBankId);
      } else {
        this.tabsList = [];
        this.topicList = [];
        this.detailsList = [];
      }
    },
    async getByStudyBankIdList(studyBankId) {
      const { data } = await getByStudyBankId(studyBankId);
      this.topicList = data.studyBankCategories;
    },
    titleRightClick() {
      this.suspensionFlag = !this.suspensionFlag;
    },
    tabsClick(item, index) {
      this.tabsActive = index;
      console.log("item", item);
      this.getByStudyBankIdList(item.studyBankId);
      this.topicActive = null;
    },
    topicOneClick(item, index) {
      console.log("item", item);
      // this.isUnlock = item.isUnlock;
      // this.isDemo = item.isDemo;
      if (this.topicActive === index) {
        this.topicActive = null; // 如果点击的是同一个，则将 this.topicActive 设置为 null
      } else {
        this.topicActive = index; // 如果点击的是不同的项，则将 this.topicActive 设置为 index
        this.detailsList = item.children;
      }
    },
    shouldShowLock(item, index) {
      if (item.isUnlock) {
        return false;
      } else if (item.isDemo) {
        return index >= 1;
      } else {
        return true;
      }
    },
    topicTwoClick(item, index) {
      // if (!this.shouldShowLock(item, index) && item.totalNum > 0) {
        this.$router.push({
          path: "/subjectHomeWork",
          query: {
            // studyBankId: item.studyBankId,
            // isUnlock: this.isUnlock,
            categoryId: item.id,
            typeFlag: 0,
            name: "topic",
            topicActive: this.topicActive,
            code: item.code,
            label: item.label,
            skillId: this.skillId,
            skillName: this.skillName,
            skillIntegral: this.skillIntegral,
            majorType: this.majorType,
          },
        });
      // } else {
      //   this.androidIos();
      // }
    },

    suspensionLeftListClick(item, index) {
      this.suspensionLeftActive = index;
      this.suspensionRightActive = 0;
      if (item.children) {
        this.suspensionRightList = item.children;
        // this.getStudyBankList(data[0].children[0].id);
        this.suspensionRightActive = 0;
        this.getStudyBankList(this.suspensionRightList[0].id);
      } else {
        this.suspensionRightList = [];
        this.tabsList = [];
        this.topicList = [];
        this.detailsList = [];
      }
    },
    suspensionRightListClick(item, index) {
      this.suspensionRightActive = index;
      this.getStudyBankList(item.id);
      this.tabsActive = 0;
      this.topicActive = null;
      this.suspensionFlag = false;
      this.titleRightFlag = false;
    },
    // 错题
    wrongQuestion() {
      this.$router.push({
        path: "/subjectErrorCorrection",
        query: {
          majorType: this.majorType,
        },
      });
    },
    // 笔记
    note() {
      this.$router.push({
        path: "/subjectNote",
        query: {
          majorType: this.majorType,
        },
      });
    },
    // 收藏
    collect() {
      this.$router.push({
        path: "/subjectCollect",
        query: {
          majorType: this.majorType,
        },
      });
    },
    // 组题
    testCreation() {
      this.$router.push({
        path: "/subjectGroupQuestion",
        query: {
          majorType: this.majorType,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.topicBox {
  .gradientBox {
    width: 100%;
    height: 220px;
    background: linear-gradient(
      180deg,
      rgba(196, 249, 247, 0.5),
      rgba(255, 255, 255, 0) 100%
    );
    .titleBox {
      padding: 44px 16px 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .titleLeft {
        text-align: center;
        line-height: 20px;
        width: 20px;
        height: 20px;
        img {
          width: 20px;
          height: 20px;
        }
      }
      .titleCentre {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 17px;
        color: #121212;
        line-height: 24px;
        text-align: left;
        font-style: normal;
      }
      .titleRight {
        width: 28px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        border-radius: 50%;
        // background: rgba(27, 191, 141, 0.1);
        display: flex;
        justify-content: center;
        align-items: center;
        transition: transform 200ms ease;
        backface-visibility: hidden;
        img {
          width: 14px;
          height: 14px;
        }
      }
      .active {
        transform: rotate(180deg);
      }
    }
    .typeBox {
      padding: 0 16px;
      z-index: 999;
      margin-top: 32px;
      display: flex;
      justify-content: space-between;
      padding: 0 19px;
      width: 100%;
      height: 69px;
      li {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        // width: 48px;
        height: 69px;
        list-style: none;
        img {
          width: 44px;
          height: 44px;
          border-radius: 50%;
        }
        span {
          // margin-top: 10px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #333333;
          text-align: left;
          font-style: normal;
        }
      }
    }
    .tabsBox {
      padding: 0 16px;
      z-index: 999;
      margin-top: 25px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 17px;
      color: #121212;
      line-height: 24px;
      text-align: left;
      font-style: normal;

      .tabs {
        display: flex;
        height: 36px;
        overflow-x: auto;
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
        &::-webkit-scrollbar {
          display: none; /* Chrome, Safari, Opera */
        }
        li {
          margin-right: 10px;
          padding: 0 11px;
          height: 32px;
          background: #f5f6f5;
          border-radius: 8px;
          list-style: none;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          white-space: nowrap;
          font-size: 14px;
          color: #81838d;
          line-height: 32px;
          text-align: left;
          font-style: normal;
        }
        .active {
          position: relative;
          color: #ffffff;
          background: #1bbf8d;
        }
        .active::after {
          content: "";
          position: absolute;
          left: 50%; /* 倒三角水平居中 */
          bottom: -3px; /* 倒三角放在长方形下方 */
          width: 0;
          height: 0;
          border-left: 4px solid transparent; /* 左边边框透明 */
          border-right: 4px solid transparent; /* 右边边框透明 */
          border-top: 4px solid #1bbf8d; /* 上边边框为长方形颜色 */
          transform: translateX(-50%); /* 水平居中调整 */
        }
      }
    }
  }
  .topicOneBox {
    padding: 0 16px;
    margin-top: 14px;
    li {
      list-style: none;
      .topicOne {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 55px;
        border-bottom: 1px solid #eeeeee;
        .oneLeft {
          display: flex;
          justify-content: center;
          align-items: center;
          .arrow {
            display: flex;
            justify-content: center;
            align-content: center;
            margin-right: 8px;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background: #1bbf8d;
            transition: transform 200ms ease; /* Add transition */
          }
          .title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #000000;
            text-align: left;
            font-style: normal;
          }
        }
        .oneRight {
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #999999;
          text-align: left;
          font-style: normal;
          span:first-child {
            display: inline-block;
            color: #1bbf8d;
          }
        }
      }
      .topicTow {
        li {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          height: 55px;
          border-bottom: 1px solid #eeeeee;
          .towLeft {
            margin-left: 24px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            text-align: left;
            font-style: normal;
          }
          .towRight {
            display: flex;
            align-items: center;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #999999;
            text-align: left;
            font-style: normal;
            span {
              margin-left: 5px;
            }
          }
        }
      }
    }
    .active .arrow {
      transform: rotate(180deg);
    }
  }
  @keyframes slideDown {
    from {
      transform: translateY(-72px); /* 从元素上方滑入 */
      opacity: 0; /* 初始透明度为0 */
    }
    to {
      transform: translateY(0); /* 滑入到距离顶部28px的位置 */
      opacity: 1; /* 结束时完全不透明 */
    }
  }
  @keyframes slideUp {
    from {
      transform: translateY(0); /* 从元素上方滑入 */
      opacity: 1; /* 初始透明度为0 */
    }
    to {
      transform: translateY(-100%); /* 滑入到距离顶部28px的位置 */
      opacity: 0; /* 结束时完全不透明 */
    }
  }
  /* Apply animation when active */
  // .suspensionBox .suspension.active {
  //   animation: slideDown 0.5s forwards; /* Sliding down animation */
  // }

  // /* Apply animation when not active */
  // .suspensionBox .suspension {
  //   animation: slideUp 0.5s forwards; /* Sliding up animation */
  // }
  .suspensionBox {
    padding-top: 44px;
    .titleCentre {
      width: 100%;
      height: 44px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 17px;
      color: #121212;
      line-height: 44px;
      text-align: center;
      font-style: normal;
    }
    .suspension {
      display: flex;
      width: 100%;
      height: 252px;
      background: #ffffff;
      border-radius: 0px 0px 16px 16px;
      z-index: 1001; /* 设置较低的 z-index 值，以便被 .titleBox 遮盖 */
      .suspensionLeft {
        margin-left: 16px;
        margin-right: 21px;
        width: 150px;
        height: 252px;
        overflow-y: auto;
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
        &::-webkit-scrollbar {
          display: none; /* Chrome, Safari, Opera */
        }
        li {
          display: flex;
          align-items: center; /* Center items vertically */
          width: 150px;
          height: 55px;
          border-bottom: 1px solid #eeeeee;

          .suspensionLeftName {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            // line-height: 55px;
            text-align: left;
            font-style: normal;
            word-break: break-word;
          }
        }
        .active {
          .suspensionLeftName {
            font-weight: 600;
            color: #000000;
          }
        }
      }
      .suspensionRight {
        padding: 18px 0;
        width: 172px;
        height: 252px;
        overflow-y: auto;
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
        &::-webkit-scrollbar {
          display: none; /* Chrome, Safari, Opera */
        }
        li {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 10px;
          width: 172px;
          height: 34px;
          text-align: center;
          line-height: 34px;
          background: #f5f6f6;
          border-radius: 8px;
          list-style: none;
          .suspensionRightName {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #81838d;
            text-align: left;
            font-style: normal;
          }
        }
        .active {
          background: rgba(27, 191, 141, 0.1);
          .suspensionRightName {
            color: #1bbf8d;
          }
        }
      }
    }
  }

  // @keyframes cardUp {
  //   from {
  //     transform: translateY(100%); /* 从元素上方滑入 */
  //     opacity: 0; /* 初始透明度为0 */
  //   }
  //   to {
  //     transform: translateY(0);
  //     opacity: 1; /* 结束时完全不透明 */
  //   }
  // }
  // @keyframes cardDown {
  //   from {
  //     transform: translateY(0); /* 从元素上方滑入 */
  //     opacity: 1; /* 初始透明度为0 */
  //   }
  //   to {
  //     transform: translateY(100%);
  //     opacity: 0; /* 结束时完全不透明 */
  //   }
  // }
  /* Apply animation when active */
  .cardBox .card.active {
    animation: cardUp 0.5s forwards; /* Sliding down animation */
  }

  /* Apply animation when not active */
  .cardBox .card {
    animation: cardDown 0.5s forwards; /* Sliding up animation */
  }
  .cardBox {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);

    .card {
      padding: 8px 21px;
      position: absolute;
      bottom: 0; /* 初始状态在底部之外 */
      width: 375px;
      max-height: 520px;
      background: #ffffff;
      border-radius: 16px 16px 0px 0px;
      backdrop-filter: blur(6px);
      .cardTitle {
        margin-top: 18px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 17px;
        color: #2f2f46;
        text-align: center;
        font-style: normal;
      }
      .cardUl {
        margin-top: 16px;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        gap: 10px; /* 添加间距 */
        width: 100%;
        transition: max-height 0.5s ease-in-out;
      }

      li {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: #ffffff;
        border: 1px solid #dddddd;
        list-style: none;
        font-family: ArialMT;
        font-size: 13px;
        color: #8b949a;
        line-height: 28px;
        text-align: center;
        font-style: normal;
      }
      .active {
        background: #1bbf8d;
        color: #ffffff;
      }
    }
  }
}
</style>
